import { Skeleton, styled } from "@mui/material";

const SkeletonTable = styled("table")`
  background-color: #fff;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;

  th,
  td {
    padding: 5px 10px;
    text-align: left;

    &:first-child {
      padding-left: 20px;
    }
  }

  th {
    height: 30px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.line.main};
  }

  td {
    border-bottom: 1px dashed ${({ theme }) => theme.palette.line.main};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

const CELL_WIDTHS = [90, 110, 70, 100, 60, 95, 55, 80];

interface Props {
  columnCount?: number;
  rowCount?: number;
}

const TableSkeleton = (props: Props) => {
  const columnCount = props.columnCount ?? 6;
  const rowCount = props.rowCount ?? 8;

  return (
    <SkeletonTable>
      <thead>
        <tr>
          {[...Array(columnCount)].map((_, columnIndex) => (
            <th key={columnIndex}>
              <Skeleton variant="text" width={CELL_WIDTHS[columnIndex % CELL_WIDTHS.length]} height={20} />
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {[...Array(rowCount)].map((_, rowIndex) => (
          <tr key={rowIndex}>
            {[...Array(columnCount)].map((_, columnIndex) => (
              <td key={columnIndex}>
                <Skeleton
                  variant="text"
                  width={CELL_WIDTHS[(columnIndex + rowIndex) % CELL_WIDTHS.length]}
                  height={20}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </SkeletonTable>
  );
};

export { TableSkeleton };
